import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// Import's Service:
import {
  ServicioComfenalcoService,
  ComfenalcoServiceEntity,
  ObjetoComfenalcoEntity
} from "../../services/servicio-comfenalco.service";
import { DataPermisosService } from "src/app/services/utils/data-permisos.service";
import { ExcelService } from "src/app/services/utils/excel.service";

@Component({
  selector: "app-reporte-comfenalco",
  templateUrl: "./reporte-comfenalco.component.html",
  styleUrls: ["./reporte-comfenalco.component.css"]
})
export class ReporteComfenalcoComponent implements OnInit {

  private objetoComfenalco: ComfenalcoServiceEntity = {
    codigoBaseDatos: "",
    uncoEmpresa: 0,
    fechaInicial: "",
    fechaFinal: ""
  };

  public arrayObjetoComfenalcoEntity : ObjetoComfenalcoEntity[] = [];

  public objetoPermisos: any = {
    imprimir: false,
    descargar: false,
    filtros: false
  };
  public listaObjetoFiltro: ObjetoFiltroSedes[] = [];
  public objetoReporteComfenalco: any = {
    uncoEmpresa : 0,
    fechaInicial: null,
    fechaFinal: null
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioComfenalco: ServicioComfenalcoService,
    private dataPermisos: DataPermisosService,
    private servicioExcel: ExcelService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.objetoComfenalco.codigoBaseDatos = params["codigoBaseDatos"];
    });

    this.getPermisos();
  }

  public async getPermisos() {
    let ruta: string = await this.activatedRoute.snapshot.url[0].path;
    let result: any = await this.dataPermisos.getPermisos(ruta);

    if (result != null) {
      this.objetoPermisos = result;
    }
  }

  ngOnInit() {
    this.getFilters();
  }

  public async getObjetoReporteComfenalco(objeto: any) {
    this.objetoReporteComfenalco = await objeto;
  }

  private async getBodyReportComfenalco( objeto : any ) {
    try {
      let response = await this.servicioComfenalco.getBodyReport(objeto);

      if (response != null) {
        response.subscribe((data: any) => {
          this.arrayObjetoComfenalcoEntity = data;
        });
      }
    } catch (exception) {
      console.log(exception);
    }
  }

  private async getFilters() {
    try {
      let response = await this.servicioComfenalco.getResponseFiltersEmpresas(
        this.objetoComfenalco
      );

      if (response != null) {
        response.subscribe((data: any) => {
          this.listaObjetoFiltro = data;
        });
      }
    } catch (exception) {
      console.log(exception);
    }
  }

  public getGenerar(param: any) {
    if( this.objetoReporteComfenalco != null ) {
      this.objetoComfenalco.uncoEmpresa = this.objetoReporteComfenalco.uncoEmpresa;
      this.objetoComfenalco.fechaInicial = this.objetoReporteComfenalco.fechaInicial;
      this.objetoComfenalco.fechaFinal = this.objetoReporteComfenalco.fechaFinal;

      this.getBodyReportComfenalco(this.objetoComfenalco);
    }
  }

  getDescargar(){
    this.onDescargarExcel();
  }

  onDescargarExcel(){

    if(this.arrayObjetoComfenalcoEntity.length > 0){

      let data = [];

      for (let item of this.arrayObjetoComfenalcoEntity) {

        let obj = {};

        obj['Tipo Identificacion'] = item.afiliado.tipoIdentificacion;
        obj['Identificacion'] = item.afiliado.identificacion;
        obj['Fecha Nacimiento'] = item.afiliado.fechaNacimiento;
        obj['Sexo'] = item.afiliado.sexo;

        delete item.afiliado;

        let map = Object.keys(item);
        for (let key of map) {
          obj[key] = item[key];
        }
        data.push(obj);
      }

      this.servicioExcel.exportAsExcelFile(data, 'Comfenalco', 'Comfenalco');

    }else{
      alert('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
    }
  }

}

interface ObjetoFiltroSedes {
  idSede: string;
  descripcion: string;
}
